import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { TranslationService } from 'src/app/Service/translation.service';
import { CONSTANTS } from '../../../../Core/Constant';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-other-personal-information',
  templateUrl: './other-personal-information.component.html',
  styleUrls: ['./other-personal-information.component.scss']
})
export class OtherPersonalInformationComponent {
  @Input() applicantData: any; // Accept data from parent component
  @Input() isPreviewMode: boolean = false; // Flag to determine behavior
  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();

  spiritualHistoryForm!: FormGroup;
  submitted = false;
  SaveMode = CONSTANTS.SAVE_MODE;
  isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment
  selectedLanguage: string = 'en'; // Default language
  isEditable: boolean = true; // Flag to track if the form is editable

  constructor(
    private toastr: ToastrService, 
    private api: SevaProfileService, 
    private fb: FormBuilder, 
    public genericValidations: GenericValidationsService,
    private translationService: TranslationService
  ) { }

  ngOnInit(): void {
    // Load saved language preference
    this.selectedLanguage = this.translationService.getCurrentLanguage();

    if (!this.isPreviewMode) {
      // Execute only when not in preview mode
      this.initializeForm();
      this.getApplicantData();
    }
  }

  // Get translation for current language
  getTranslation(key: string): string {
    return this.translationService.getTranslation(key);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['applicantData'] && this.applicantData) {
      this.initializeForm();
      this.spiritualHistoryForm.patchValue(this.applicantData);
      this.spiritualHistoryForm.disable();
    }
  }

  getApplicantData() {
    this.api.apiCall('SpiritualHistory/GetSpiritualHistory', 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage); // Example: Set progress to 50%

        // Store IsEditable flag from response
        this.isEditable = response.Data.IsEditable !== false; // Default to true if not provided

        // Disable form if not editable
        if (!this.isEditable) {
          this.spiritualHistoryForm.disable();
        } else {
          this.spiritualHistoryForm.enable();
        }

        this.spiritualHistoryForm.patchValue(response.Data);
      }
    })
  }


  initializeForm() {
    this.spiritualHistoryForm = this.fb.group({
      IsInvolvedWithOtherSpiritual: [null, Validators.required],
      OtherOrganisationDetails: ['', Validators.required],
      IsAskedToLeaveAshram: [null, Validators.required],
      ReasonForAskToLeave: ['', Validators.required],
      IsHavingCriminalOffence: [null, Validators.required],
      OffenceDetails: ['', Validators.required],
      IsHavingDrugHistory: [null, Validators.required],
      DrugHistoryDetails: ['', Validators.required],
      SaveMode: ['', Validators.required],
    });

    const controlMappings = {
      'IsAskedToLeaveAshram': ['ReasonForAskToLeave'],
      'IsHavingCriminalOffence': ['OffenceDetails'],
      'IsInvolvedWithOtherSpiritual': ['OtherOrganisationDetails'],
      'IsHavingDrugHistory': ['DrugHistoryDetails',]
    };


    // Call the service with the isShowOn parameter set to true or false as needed
    this.genericValidations.setupFormListeners(this.spiritualHistoryForm, controlMappings, true);

    // Emit the form group to parent component
    this.formGroupChange.emit(this.spiritualHistoryForm);
  }



  onSubmit(Mode: number): void {

    // this.spiritualHistoryForm.patchValue({
    //   SaveMode: Mode
    // })

    if (!this.spiritualHistoryForm.valid && Mode == this.SaveMode.SAVE) {
      this.submitted = true;


      // Add 'submitted' class manually to all invalid controls
      Object.keys(this.spiritualHistoryForm.controls).forEach((field) => {
        const control = this.spiritualHistoryForm.get(field);
        if (control && control.invalid) {
          control.markAsTouched(); // Ensure ng-touched is triggered
          const element = document.getElementById(field);
          if (element) {
            element.classList.add('submitted'); // Add 'submitted' class to invalid elements
          }
        }
      });


      this.toastr.warning(this.getTranslation('validation.completeAllFields'));

      return
    }


    const cleanedValues = this.genericValidations.removeWhitespaceFromValues(this.spiritualHistoryForm.value);
    this.addUpdate(cleanedValues, Mode);


  }

  addUpdate(reqBoby: any, Mode: number) {
    reqBoby.SaveMode = Mode;
    this.api.apiCall('SpiritualHistory/SaveSpiritualHistory', 'POST', reqBoby).subscribe((response: any) => {
      console.log('POST response:', response);
      this.toastr.success(response?.Message);
      if (Mode == this.SaveMode.SAVE) {
        this.nextStep.emit();
      } else if (Mode == this.SaveMode.DRAFT) {
        this.getApplicantData();
      }
    });


  }

  goToBack(): void {
    this.previous.emit();
  }

}
